$(document).ready(function(){
  if($('.toggle-read-more').length > 0){
    let content = $('.coll-full-desc').html();
    let preText = content.substring(0, content.indexOf('</p>'));
    //let preText = $('.coll-full-desc').find("p:first").html();
    let postText = content.substring(content.indexOf('</p>') + 5, content.length);
    $('.toggle-read-more').html('');
    $('.toggle-read-more').html('<div class="preText 1">'+preText+'</div> <span data-section="coll_description" class="link_readmore"> Read More</span><span style="display:none;" class="link_readless text-red"> Read Less</span>')
    $('.collection-desc-bottom').html(postText)
    
    $(document).on('click','.link_readmore', function(){
      //redirect to section
      event.preventDefault();
      if ($(".boost-sd__pagination-load-more-container-item").length > 0){
        var aTag = $(".boost-sd__pagination-load-more-container-item").offset().top;  
      }
      else{
        var aTag = $("[data-desc='coll_description']").offset().top;
        var aTag = aTag - 100
      }
      $('html,body').animate({scrollTop: aTag}, 1500);
    })
    $(document).on('click','.link_readless', function(){
        $(this).hide();
        $('.link_readmore').show();
        $('.postText').hide();
    })
  }
})